import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Toast from "../LoadingError/Toast";
import {listSupplier} from "../../Redux/Actions/SupplierActions";
import {createExpense} from "../../Redux/Actions/ExpenseActions";


const ToastObjects = {
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: true,
    autoClose: 10000,
};
const AddExpenseMain = () => {

    const dispatch = useDispatch();


    const supplierList = useSelector((state) => state.supplierList);
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    useEffect(() => {
        dispatch(listSupplier());
    }, [dispatch]);




    //--------------------EXPENSE DETAIL---------------------
    const [expenseTitle, setExpenseTitle] = useState("");
    const [expenseDescription, setExpenseDescription] = useState("");
    const [expenseTotalPrice, setExpenseTotalPrice] = useState(0);
    const [expensePaidAmount, setExpensePaidAmount] = useState(0);
    const [expenseDueAmount, setExpenseDueAmount] = useState(0);
    const [expenseCategory, setExpenseCategory] = useState("");
    const [boughtSomething, setBoughtSomething] = useState("Select Yes Or No");
    const [expenseNumberOfKilos, setExpenseNumberOfKilos] = useState("");
    const [expenseNumberOfPieces, setExpenseNumberOfPieces] = useState("");
    const [expenseNumberOfMetres, setExpenseNumberOfMetres] = useState("");
    const [expenseDate, setExpenseDate] = useState("");
    //                    -----------Unity----------

    const tableOfUnits = ["Select a unit","kilos","meters","centimeters","grams","pieces","liters"];
    const [unit, setUnit] = useState(tableOfUnits[0]);

    //                        -----------boughtSomethingsDetails----------

    const [detailsOfBoughtItems, setDetailsOfBoughtItems] = useState(
        [
        {
        title: '',
        unit: '',
        quantity: 0,
        priceOfItem: 0,
            totalPriceOfBoughtItems:0
        },
        ]
    );



    //                  -----------PAID PERSONS DETAILS
    const [firstTimeWithSupplier,setFirstTimeWithSupplier]=useState("Select Yes Or No")
    const [selectRegisteredSupplier,setSelectRegisteredSupplier]=useState("Select Yes Or No")
    //                        -----------personsPaidDetails----------

    const [paidSuppliersDetails, setPaidSuppliersDetails] = useState(
        [
        {
        supplierName: "",
        amountPaidToSupplier: 0,
        supplierAddress: "",
        supplierCity: "",
        supplierPostalCode: "",
        supplierCountry: "",
        supplierPhone: "",
        supplierEmail: "",
    }
        ]
    );


    const [paidSelectedSuppliersDetails, setPaidSelectedSuppliersDetails] = useState(
        [
            {
                selectedSupplierId: "",
                supplierName:"",
                amountPaidToSupplier: 0,

            }
        ]
    );



    const calculateTotalPriceOfBoughtItems=(index)=>{
        let data = [...detailsOfBoughtItems];
        data[index]["totalPriceOfBoughtItems"] = data[index]["priceOfItem"] * data[index]["quantity"] ;
        setDetailsOfBoughtItems(data);
    }




    const changeHandlerOfBoughtItems = (event, index) => {
        let data = [...detailsOfBoughtItems];
        data[index][event.target.name] = event.target.value;
        setDetailsOfBoughtItems(data);
    }

    const changeHandlerOfPaidSuppliers = (event, index) => {
        let data = [...paidSuppliersDetails];
        data[index][event.target.name] = event.target.value;
        setPaidSuppliersDetails(data);
    }

    const changeHandlerOfSelectedPaidSuppliers = (supplier, index,e="") => {
        let data = [...paidSelectedSuppliersDetails];
        if(supplier._id){
        data[index]["selectedSupplierId"] = supplier._id;
        setPaidSelectedSuppliersDetails(data);
        }
        if(supplier.name){
            data[index]["supplierName"] = supplier.name;
            setPaidSelectedSuppliersDetails(data);
        }


        if(e && e.target.value>0){
            data[index]["amountPaidToSupplier"] = e.target.value;
            setPaidSelectedSuppliersDetails(data);
        }


        console.log(data);
    }



    const addFieldsOfBoughtItems = () => {
        let object = {
            title: '',
            unit: '',
            quantity: '',
            priceOfItem: ''
        }

        setDetailsOfBoughtItems([...detailsOfBoughtItems, object])
    }

    const addFieldsOfPaidSuppliers = () => {
        let object = {
            supplierName: "",
            amountPaidToSupplier: "",
            supplierAddress: "",
            supplierCity: "",
            supplierPostalCode: "",
            supplierCountry: "",
            supplierPhone: "",
            supplierEmail: "",
        }
        setPaidSuppliersDetails([...paidSuppliersDetails, object])
    }
    const addFieldsOfSelectedPaidSuppliers = () => {
        let object = {
            selectedSupplierId: "",
            supplierName:"",
            amountPaidToSupplier: 0,
        }
        setPaidSelectedSuppliersDetails([...paidSelectedSuppliersDetails, object])
    }



    const calculateTotalPrice=()=>{
        let amount = 0;
        detailsOfBoughtItems.map(item=>{
            if(item.totalPriceOfBoughtItems!==0) {
                amount += parseFloat(item.totalPriceOfBoughtItems)
            }
        }
        )

        paidSuppliersDetails.map(item=>{
            if(item.amountPaidToSupplier!=="") {
                amount += parseFloat(item.amountPaidToSupplier)
            }
        }
        )

        paidSelectedSuppliersDetails.map(item=>{
            if(item.amountPaidToSupplier!=="") {
                amount += parseFloat(item.amountPaidToSupplier)
            }
        }
        )

        setExpenseTotalPrice(amount)
    }

    //---------------------------------
    const [validExpenses, setValidExpenses] = useState(true);








    const productCreate = useSelector((state) => state.productCreate);
    const { loading, error, product } = productCreate;

    const categoryList = useSelector((state) => state.categoryList);
    const { loading: loadingCategory, error: errorCategory, categories } = categoryList;


    const calculateDueAmount = () => {
        let dueAmount = expenseTotalPrice - expensePaidAmount;
        if(dueAmount < 0){
            setExpenseDueAmount(0);
            toast.warn("Paid Amount is greater than Price", ToastObjects);
            setValidExpenses(false);
        }
        setExpenseDueAmount(dueAmount);
    }


    const removeFieldsOfBoughtItems = (index) => {
        let data = [...detailsOfBoughtItems];
        data.splice(index, 1)
        setDetailsOfBoughtItems(data)
    }
    const removeFieldsOfDetailsOfPaidSuppliers = (index) => {
        let data = [...paidSuppliersDetails];
        data.splice(index, 1)
        setPaidSuppliersDetails(data)
    }
    const removeFieldsOfDetailsOfSelectedPaidSuppliers = (index) => {
        let data = [...paidSelectedSuppliersDetails];
        data.splice(index, 1)
        setPaidSelectedSuppliersDetails(data)
    }


    const isFormValid = () => {
        let validForm = true;

        if (expenseTotalPrice < 0) {
            toast.warn("Total Price is less than 0", ToastObjects);
            setValidExpenses(false);
        }


        if(boughtSomething=='true'){
            if(detailsOfBoughtItems.length<1){
                toast.warn("Please add atleast one item", ToastObjects);
                validForm = false;
            }
            else if(detailsOfBoughtItems.length>0){
                detailsOfBoughtItems.map(item=>{
                    if(item.title==="" || item.unit==="" || item.quantity==="" || item.priceOfItem===""){
                        toast.warn("Please fill all the fields", ToastObjects);
                        validForm = false;
                    }
                }
                )
            }
        }

       if(firstTimeWithSupplier=='true'){
              if(paidSuppliersDetails.length<1){
                toast.warn("Please add atleast one supplier", ToastObjects);
                  validForm = false;
              }
              else if(paidSuppliersDetails.length>0){
                paidSuppliersDetails.map(item=>{
                     if(item.supplierName==="" ){
                          toast.warn("Please fill atLeast the name", ToastObjects);
                         validForm = false;
                     }
                }
                )
              }
       }
       if(selectRegisteredSupplier=='true'){
            if(paidSelectedSuppliersDetails.length<1){
                toast.warn("Please add atleast one supplier", ToastObjects);
                validForm = false;
            }
            else if(paidSelectedSuppliersDetails.length>0){
                paidSelectedSuppliersDetails.map(item=>{
                     if(item.selectedSupplierId==="" || item.amountPaidToSupplier===""){
                          toast.warn("Please fill all the fields", ToastObjects);
                          validForm = false;
                     }
                }
                )
            }
       }






        if( ! ( (selectRegisteredSupplier=="true") || (firstTimeWithSupplier=="true") ) ){
            //toast with duration of 5 seconds
            toast.warn("Please select a supplier or add a new supplier", ToastObjects);

            validForm = false;
        }

        return (validForm&&validExpenses);



    }



    const handleSubmit = (e) => {
        e.preventDefault();


        if (isFormValid()) {
            let data = {
                seller: userInfo._id,
                expenseTitle: expenseTitle,
                expenseDescription: expenseDescription,
                expenseDate: expenseDate,
                detailsOfBoughtItems: detailsOfBoughtItems,
                paidSuppliersDetails: paidSuppliersDetails,
                paidSelectedSuppliersDetails: paidSelectedSuppliersDetails,
                expenseTotalPrice: expenseTotalPrice,
                expensePaidAmount: expensePaidAmount,
                expenseDueAmount: expenseDueAmount,
            }
            console.log(data);

            dispatch(createExpense(data));
            //reset the form
            setExpenseTitle("");
            setExpenseDescription("");
            setExpenseDate("");
            setDetailsOfBoughtItems([
                {
                    title: '',
                    unit: '',
                    quantity: 0,
                    priceOfItem: 0,
                    totalPriceOfBoughtItems:0
                },
            ]);
            setPaidSuppliersDetails([
                {
                    supplierName: "",
                    amountPaidToSupplier: 0,
                    supplierAddress: "",
                    supplierCity: "",
                    supplierPostalCode: "",
                    supplierCountry: "",
                    supplierPhone: "",
                    supplierEmail: "",
                }
            ]);
            setPaidSelectedSuppliersDetails([
                {
                    selectedSupplierId: "",
                    supplierName:"",
                    amountPaidToSupplier: 0,

                }
            ]);
            setExpenseTotalPrice(0);
            setExpensePaidAmount(0);
            setExpenseDueAmount(0);


        }
    }


    return (
        <>
            <Toast />
            <section className="content-main container" style={{ maxWidth: "1200px" }}>
                <form onSubmit={handleSubmit} >
                    <div className="content-header">
                        <Link to="/products" className="btn btn-danger text-white">
                            Go to Expenses
                        </Link>
                        <h2 className="content-title">Add Expense</h2>
                        <div>
                            <button type="submit" className="btn btn-primary">
                                Add Expense now
                            </button>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-xl-8 col-lg-8">
                            <div className="card mb-4 shadow-sm">
                                <div className="card-body">


                                    <div className="form-group">
                                        <label htmlFor="expenseTitle">Expense Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="expenseTitle"
                                            value={expenseTitle}
                                            onChange={(e) => setExpenseTitle(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="expenseDescription">Expense Description</label>
                                        <textarea
                                            className="form-control"
                                            id="expenseDescription"
                                            value={expenseDescription}
                                            onChange={(e) => setExpenseDescription(e.target.value)}

                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="expenseDate">Expense Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="expenseDate"
                                            value={expenseDate}
                                            onChange={(e) => setExpenseDate(e.target.value)}
                                            //default valut today
                                            required
                                        />
                                    </div>




                                    <div  className="mt-3 mb-3 border border-dark rounded p-2">

                                    <div className="form-group">
                                        <label htmlFor="expenseCategory">Bought Something ?</label>
                                        <select
                                            className="form-control"
                                            id="boughtSomething"
                                            value={boughtSomething}
                                            onChange={(e) => setBoughtSomething(e.target.value)}
                                        >
                                            <option value="">Select Yes | No</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>

                                    {boughtSomething === "true" && (
                                        <p className="text-center display-6 mt-2 mb-2">Bought Items Details</p>
                                    )}

                                    {boughtSomething === "true" &&  (
                                       //    first select unit (map over table of units)
                                        detailsOfBoughtItems.map((item, index) => (
                                            <>

                                            <div key={index} className="mt-3 mb-3 border border-dark rounded p-2">

                                                <div className="form-group ">
                                                    <label htmlFor="BoughtSomethingTitle">Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="BoughtSomethingTitle"
                                                        name="title"
                                                        value={item.title}
                                                        onChange={(e) => changeHandlerOfBoughtItems(e,index)}
                                                        required
                                                        />
                                                </div>


                                                <div className="form-group">
                                                    <label htmlFor="BoughtSomethingUnit">Unit</label>
                                                    <select
                                                        className="form-control"
                                                        id="BoughtSomethingUnit"
                                                        name="unit"
                                                        value={item.unit}
                                                        defaultValue="kilos"
                                                        onChange={(e) => changeHandlerOfBoughtItems(e,index)}
                                                    >
                                                        {tableOfUnits.map((unit, index) => (
                                                            <option key={index} value={unit}>{unit}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="BoughtSomethingQuantity">Quantity</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="quantity"
                                                        min="1"
                                                        id="BoughtSomethingQuantity"
                                                        value={item.quantity}
                                                        onChange={(e) => {
                                                            changeHandlerOfBoughtItems(e,index)
                                                            calculateTotalPriceOfBoughtItems(index)
                                                            calculateTotalPrice()
                                                        }}
                                                        onBlur={calculateDueAmount}
                                                        required
                                                        />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="BoughtSomethingPrice">Price</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="BoughtSomethingPrice"
                                                        name="priceOfItem"
                                                        min="0"
                                                        value={item.priceOfItem}
                                                        onChange={(e) => {changeHandlerOfBoughtItems(e,index)
                                                            calculateTotalPriceOfBoughtItems(index)
                                                            calculateTotalPrice()
                                                        }
                                                    }
                                                        onBlur={calculateDueAmount}
                                                        required
                                                    />
                                                </div>
                                                <label htmlFor="BoughtSomethingPrice">Total Price Of {item.title} </label>

                                                <div className="form-group input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">TND</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="BoughtSomethingPrice"
                                                        name="totalPriceOfBoughtItems"
                                                        //show value with dollar

                                                        value={
                                                        item.totalPriceOfBoughtItems
                                                        }
                                                        disabled
                                                    />
                                                </div>


                                                <div className="col-md-12 text-center">
                                                    <button
                                                        className="btn btn-danger mt-2"
                                                        onClick={() => {removeFieldsOfBoughtItems(index)
                                                        }}>Remove</button>
                                                </div>

                                            </div>
                                            </>
                                        ))
                                    )
                                    }
                                    {boughtSomething === "true" && (
                                        //add more items button
                                        <div className="col-md-12 text-center mt-2 mb-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() =>
                                                addFieldsOfBoughtItems()
                                            }
                                            >
                                            Add More Items
                                        </button>
                                        </div>
                                    )}
                                    </div>






                                    {/*    paid person ? */}

                                    <div className="mt-3 mb-3 border border-dark rounded p-2 ">
                                    <div className="form-group">
                                        <label htmlFor="firstTimeWithSupplier">Wanna add a supplier Manually ?</label>
                                        <select
                                            className="form-control"
                                            id="firstTimeWithSupplier"
                                            value={firstTimeWithSupplier}
                                            onChange={(e) => setFirstTimeWithSupplier(e.target.value)}
                                        >
                                            <option value="">Select Yes | No</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>

                                    {firstTimeWithSupplier === "true" && (
                                        <p className="text-center display-6 mt-2 mb-2">Paid Persons Details</p>
                                    )
                                    }

                                    {firstTimeWithSupplier === "true" && (

                                       paidSuppliersDetails.map((item, index) => (
                                            <>
                                            <div key={index} className="mt-3 mb-3 border border-dark rounded p-2">
                                                <div className="form-group">
                                                    <label htmlFor="paidSupplierName">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="supplierName"
                                                        name="supplierName"
                                                        value={item.supplierName}
                                                        onChange={(e) => changeHandlerOfPaidSuppliers(e,index)}
                                                        required
                                                        />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="paidSupplierPhone">Phone</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="supplierPhone"
                                                        name="supplierPhone"
                                                        value={item.supplierPhone}
                                                        onChange={(e) => changeHandlerOfPaidSuppliers(e,index)}
                                                        />
                                                </div>

                                                <label htmlFor="paidSupplierPhone">Amount Paid to {item.supplierName}</label>
                                                <div className="form-group input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">TND</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="amountPaidToSupplier"
                                                        min="0"
                                                        name="amountPaidToSupplier"
                                                        value={item.amountPaidToSupplier }
                                                        onChange={(e) => {
                                                            changeHandlerOfPaidSuppliers(e, index)
                                                            calculateTotalPrice()
                                                        }
                                                        }
                                                        onBlur={calculateDueAmount}
                                                    />
                                                </div>


                                                <div className="form-group">
                                                    <label htmlFor="paidSupplierAddress">Address</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="supplierAddress"
                                                        name="supplierAddress"
                                                        value={item.supplierAddress}
                                                        onChange={(e) => changeHandlerOfPaidSuppliers(e,index)}
                                                        />
                                                </div>

                                                <div className="form-group">
                                                        <label htmlFor="paidSupplierAddress">City</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="supplierCity"
                                                        name="supplierCity"
                                                        value={item.supplierCity}
                                                        onChange={(e) => changeHandlerOfPaidSuppliers(e,index)}
                                                    />
                                                </div>


                                                <div className="form-group">
                                                    <label htmlFor="paidSupplierAddress">Postal Code</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="supplierPostalCode"
                                                        name="supplierPostalCode"
                                                        value={item.supplierPostalCode}
                                                        onChange={(e) => changeHandlerOfPaidSuppliers(e,index)}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="paidSupplierAddress">Country</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="supplierCountry"
                                                        name="supplierCountry"
                                                        value={item.supplierCountry}
                                                        onChange={(e) => changeHandlerOfPaidSuppliers(e,index)}
                                                    />
                                                </div>


                                                <div className="form-group">
                                                    <label htmlFor="paidSupplierEmail">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        id="supplierEmail"
                                                        name="supplierEmail"
                                                        value={item.supplierEmail}
                                                        onChange={(e) => changeHandlerOfPaidSuppliers(e,index)}
                                                        />
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <button
                                                        className="btn btn-danger mt-2"
                                                        onClick={() => removeFieldsOfDetailsOfPaidSuppliers(index)}>Remove</button>
                                                </div>


                                            </div>
                                            </>
                                        ))
                                    )}

                                    {firstTimeWithSupplier === "true" && (
                                        //add more items button
                                        <div className="col-md-12 text-center mt-2 mb-2">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() =>
                                                    addFieldsOfPaidSuppliers()
                                                }
                                            >
                                                Add More Suppliers
                                            </button>
                                        </div>
                                    )}
                                    </div>
                                    <div className="mt-3 mb-3 border border-dark rounded p-2">
                                    <div className="form-group">
                                        <label htmlFor="firstTimeWithSupplier">Wanna Select a registered Supplier ?</label>
                                        <select
                                            className="form-control"
                                            id="selectRegisteredSupplier"
                                            value={selectRegisteredSupplier}
                                            onChange={(e) => setSelectRegisteredSupplier(e.target.value)}
                                        >
                                            <option value="">Select Yes | No</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>

                                    {selectRegisteredSupplier === "true" && (
                                        <div>
                                            <div className="form-group mb-3 mt-3">
                                                {/*         map for every client his name and his email */}
                                                {paidSelectedSuppliersDetails.map((item, index) => (
                                                        <>
                                                            <label>Supplier {index+1}</label>
                                                            <div key={index} className="mt-3 mb-3 border border-dark rounded p-2">
                                                        <select className="form-control"
                                                                key={index}
                                                                tabIndex={index}
                                                                onChange={(e) => {
                                                                    if (e.target.value) {
                                                                        // console.log(e.target.tabIndex)
                                                                        let data=JSON.parse(e.target.value)
                                                                        changeHandlerOfSelectedPaidSuppliers(data,index)
                                                                    }
                                                                }
                                                                }
                                                        >
                                                            <option value="">Select Supplier</option>
                                                            {supplierList.SUPPLIERS.map((supplier,index) => (
                                                                <option key={supplier._id}

                                                                        value={JSON.stringify(supplier)}
                                                                >
                                                                    {supplier.name} | {supplier.email}
                                                                </option>
                                                            ))}
                                                        </select>
                                                            <div className="form-group">
                                                                <label htmlFor="amountPaidToSelectedSupplier">Amount Paid to {item.supplierName} </label>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">TND</span>
                                                                    </div>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        id="amountPaidToSelectedSupplier"
                                                                        min="0"
                                                                        name="amountPaidToSelectedSupplier"
                                                                        value={item.amountPaidToSupplier}
                                                                        onChange={(e) => {
                                                                            changeHandlerOfSelectedPaidSuppliers("",index,e)
                                                                            calculateTotalPrice()
                                                                        }
                                                                        }
                                                                        onBlur={calculateDueAmount}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 text-center">
                                                                <button
                                                                    className="btn btn-danger mt-2"
                                                                    onClick={() => removeFieldsOfDetailsOfSelectedPaidSuppliers(index)}>Remove</button>
                                                            </div>
                                                        </div>
                                                        </>

                                                ))}
                                            </div>
                                        </div>
                                        )
                                    }

                                    {selectRegisteredSupplier === "true" && (
                                        //add more items button
                                        <div className="col-md-12 text-center mt-2 mb-2">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() =>
                                                    addFieldsOfSelectedPaidSuppliers()
                                                }
                                            >
                                                Add More Suppliers
                                            </button>
                                        </div>
                                    )}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="expensePrice">Total Expense Price</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="expensePrice"
                                            value={expenseTotalPrice}
                                            disabled
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="expensePaidAmount">Expense Paid Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="expensePaidAmount"
                                            min="0"
                                            value={expensePaidAmount}
                                            onChange={(e) => {
                                                setExpensePaidAmount(parseFloat(e.target.value))
                                            }}
                                            onBlur={() => calculateDueAmount()}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="expenseDueAmount">Expense Due Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="expenseDueAmount"
                                            value={expenseDueAmount}
                                            onChange={(e) => setExpenseDueAmount(e.target.value)}
                                            disabled
                                        />
                                    </div>




                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </>
    );

}

export default AddExpenseMain;
